import { ReactNode, useEffect } from 'react'

import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { sendSegmentPageEvent } from 'features/Monitoring/Segment/service'
import { useAuthDomainValue } from 'hooks'

import { getPath } from './pagePaths'

function PrivateRoute(props: any): ReactNode {
    const location = useLocation() || {}
    const { pathname, search, state } = location
    const signedIn = useAuthDomainValue('signedIn')
    const prevPathLink = localStorage.getItem('prevPath')

    useEffect(() => {
        const prevPath = state?.prevPath || prevPathLink

        if (signedIn && pathname && prevPath) {
            sendSegmentPageEvent(pathname, prevPath)
            if (prevPathLink) {
                localStorage.removeItem('prevPath')
            }
        } else if (signedIn && pathname) {
            sendSegmentPageEvent(pathname)
        }
    }, [signedIn, pathname, search, state, prevPathLink])

    // redirect to auth page if the user is not signed in
    if (!signedIn) {
        return <Navigate to={getPath('authPage')} state={{ from: location }} />
    }

    // return <Route {...props} />
    return <Outlet {...props} />
}

export default PrivateRoute
